import { T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS } from './TYPES'

const HU_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS: T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS =
  {
    TITLE: 'Próbaidőszak',
    DESCRIPTION:
      'A próbaidőszakod {subscriptionExpireOn}-kor lejár. Kérjük, lépj kapcsolatba egy felnőttel az előfizetésed meghosszabbításához.',
    CTA_TEXT: 'Bezárás'
  }

export default HU_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS
